(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velia-faq"] && !Shopify.designMode) return;
  try {
    
/*
  JS mínimo y delegado:
  · Soporta varias secciones FAQ en la misma página.
  · Modo acordeón: cierra las demás al abrir una.
  · Anima altura al abrir Y cerrar; mantiene [open] hasta terminar el cierre
    (importante para accesibilidad: el lector de pantalla sabe el estado real).
  · Degradación: sin este JS, <details> abre/cierra nativo igualmente.
  · Respeta prefers-reduced-motion (toggle instantáneo).
*/
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function openItem(item) {
    var ans = item.querySelector('.vp-faq__answer');
    item.setAttribute('open', '');
    if (reduce.matches) { ans.style.height = ''; return; }
    ans.style.height = '0px';
    requestAnimationFrame(function () {
      ans.style.height = ans.scrollHeight + 'px';
    });
    ans.addEventListener('transitionend', function te(e) {
      if (e.propertyName !== 'height') return;
      ans.style.height = ''; // libera a 'auto' para contenido responsive
      ans.removeEventListener('transitionend', te);
    });
  }

  function closeItem(item) {
    if (!item.hasAttribute('open')) return;
    var ans = item.querySelector('.vp-faq__answer');
    if (reduce.matches) { item.removeAttribute('open'); return; }
    ans.style.height = ans.scrollHeight + 'px';
    requestAnimationFrame(function () {
      ans.style.height = '0px';
    });
    ans.addEventListener('transitionend', function te(e) {
      if (e.propertyName !== 'height') return;
      item.removeAttribute('open');
      ans.style.height = '';
      ans.removeEventListener('transitionend', te);
    });
  }

  function initFaq(section) {
    if (section.dataset.vpInit) return;
    section.dataset.vpInit = '1';
    var accordion = section.dataset.accordion === 'true';

    section.addEventListener('click', function (e) {
      var summary = e.target.closest('.vp-faq__q');
      if (!summary) return;
      e.preventDefault(); // controlamos el toggle para poder animar el cierre
      var item = summary.parentElement;
      if (item.hasAttribute('open')) {
        closeItem(item);
      } else {
        if (accordion) {
          section.querySelectorAll('.vp-faq__item[open]').forEach(closeItem);
        }
        openItem(item);
      }
    });
  }

  function boot() { document.querySelectorAll('[data-vp-faq]').forEach(initFaq); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  // Editor de Shopify: re-inicializa al recargar la sección
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-vp-faq]'); if (s) initFaq(s);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
